// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SensorRow_sensor-row__sIR7h {
  background-color: #f1f1f1;
  border-radius: 4px;
}
.SensorRow_sensor-row__sIR7h[data-enabled=true] {
  background-color: #E5F0D8;
}

.SensorRow_row__qXBZk {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 32px;
  padding: 4px;
}

.SensorRow_row-selector__0vG36 {
  display: flex;
  align-items: center;
  padding: 0px 4px;
  gap: 8px;
  width: 80px;
}

.SensorRow_right__eL5wZ {
  flex: 1 1;
  justify-self: end;
  display: flex;
  justify-content: right;
  gap: 4px;
}

.SensorRow_label__ssiiJ {
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/SensorRow.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;AAAF;;AAGA;EACE,SAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,cAAA;AAAF","sourcesContent":[".sensor-row {\n  background-color: #f1f1f1;\n  border-radius: 4px;\n}\n.sensor-row[data-enabled=true] {\n  background-color: #E5F0D8;\n}\n\n.row {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  height: 32px;\n  padding: 4px;\n}\n\n.row-selector {\n  display: flex;\n  align-items: center;\n  padding: 0px 4px;\n  gap: 8px;\n  width: 80px;\n}\n\n.right {\n  flex: 1;\n  justify-self: end;\n  display: flex;\n  justify-content: right;\n  gap: 4px;\n}\n\n.label {\n  padding: 0 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensor-row": `SensorRow_sensor-row__sIR7h`,
	"row": `SensorRow_row__qXBZk`,
	"row-selector": `SensorRow_row-selector__0vG36`,
	"right": `SensorRow_right__eL5wZ`,
	"label": `SensorRow_label__ssiiJ`
};
export default ___CSS_LOADER_EXPORT___;
